import axios from '../../../helpers/axios';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from '../../../queries/query.keys';

export const useCustomerColumn = () => {
    return useQuery<string[], AxiosError>(QUERY_KEYS.CUSTOMER_IMPORT_COLUMNS, () =>
        axios.get<string[]>('customer/import/column/list').then((response) => response.data)
    );
};
